/**
 * La Rozen Botanicals - Create Your Arrangement Modal & Form Handler
 */
(function() {
  'use strict';

  function getElements() {
    return {
      overlay: document.querySelector('[data-custom-arrangement-overlay]'),
      modal: document.querySelector('[data-custom-arrangement-modal]'),
      forms: document.querySelectorAll('[data-custom-arrangement-form]')
    };
  }

  window.openCustomArrangementModal = function(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    var els = getElements();
    if (!els.overlay || !els.modal) return;

    els.overlay.classList.add('is-active');
    els.modal.classList.add('is-active');
    document.body.classList.add('lr-custom-modal-open');

    // Focus first input after animation
    setTimeout(function() {
      var firstInput = els.modal.querySelector('input:not([type="hidden"]), select, textarea');
      if (firstInput) firstInput.focus();
    }, 200);
  };

  window.closeCustomArrangementModal = function() {
    var els = getElements();
    if (!els.overlay || !els.modal) return;

    els.overlay.classList.remove('is-active');
    els.modal.classList.remove('is-active');
    document.body.classList.remove('lr-custom-modal-open');
  };

  // Setup click listeners and form handling
  function init() {
    // 1. Trigger listeners
    document.addEventListener('click', function(e) {
      // Open triggers
      var trigger = e.target.closest('[data-open-custom-arrangement], a[href="#create-your-arrangement"], a[href$="/pages/create-your-arrangement"]');
      if (trigger) {
        // If it's a dedicated page and the user is NOT on that page, or prefers popup
        var modal = document.querySelector('[data-custom-arrangement-modal]');
        if (modal) {
          e.preventDefault();
          window.openCustomArrangementModal(e);
        }
      }

      // Close triggers
      var closeBtn = e.target.closest('[data-close-custom-arrangement]');
      if (closeBtn) {
        e.preventDefault();
        window.closeCustomArrangementModal();
      }

      // Overlay click
      if (e.target.matches('[data-custom-arrangement-overlay]')) {
        window.closeCustomArrangementModal();
      }
    });

    // 2. Escape key listener
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var modal = document.querySelector('[data-custom-arrangement-modal].is-active');
        if (modal) {
          window.closeCustomArrangementModal();
        }
      }
    });

    // 3. Auto-open modal if URL has ?contact_posted=true or #create-your-arrangement
    if (window.location.search.indexOf('contact_posted=true') !== -1 || window.location.hash === '#create-your-arrangement') {
      setTimeout(function() {
        window.openCustomArrangementModal();
      }, 300);
    }

    // 4. Initialize Phone Fields
    initPhoneFields(document);

    // 5. Initialize Luxury Date Pickers
    initLuxuryDatepickers(document);

    // 6. Form Submission & Comprehensive Email Dossier Compilation
    var forms = document.querySelectorAll('[data-custom-arrangement-form], [data-contact-us-form], [data-corp-order-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        var submitBtn = form.querySelector('[type="submit"]');
        var submitText = submitBtn ? (submitBtn.querySelector('span') || submitBtn) : null;

        // Compile complete structured details into contact[body] & contact[Subject]
        compileFormDossier(form);

        // Update button visual state without blocking standard browser submission
        if (submitBtn) {
          if (submitText) submitText.textContent = 'Transmitting Message...';
          setTimeout(function() {
            submitBtn.disabled = true;
          }, 50);
        }
        // Allow native browser submission so Shopify backend receives and processes the contact form 100% reliably
      });
    });
  }

  function compileFormDossier(form) {
    var isArrangement = form.hasAttribute('data-custom-arrangement-form');
    var isContact = form.hasAttribute('data-contact-us-form');
    var isCorp = form.hasAttribute('data-corp-order-form');

    var nameInput = form.querySelector('[name="contact[name]"]');
    var emailInput = form.querySelector('[name="contact[email]"]');
    var phoneInput = form.querySelector('[data-phone-full]') || form.querySelector('[name="contact[phone]"]');
    var bodyTextarea = form.querySelector('textarea[name="contact[body]"]') || form.querySelector('[name="contact[body]"]');
    var subjectInput = form.querySelector('[name="contact[Subject]"]');

    var customerName = (nameInput && nameInput.value) ? nameInput.value.trim() : 'Valued Client';
    var customerEmail = (emailInput && emailInput.value) ? emailInput.value.trim() : 'Not provided';
    var customerPhone = (phoneInput && phoneInput.value) ? phoneInput.value.trim() : 'Not provided';
    
    // Retrieve clean user notes without recursive compounding
    var rawNotes = '';
    if (bodyTextarea) {
      if (bodyTextarea.getAttribute('data-raw-notes') !== null) {
        rawNotes = bodyTextarea.getAttribute('data-raw-notes');
      } else {
        rawNotes = bodyTextarea.value.trim();
        bodyTextarea.setAttribute('data-raw-notes', rawNotes);
      }
    }

    if (isArrangement) {
      var occasion = (form.querySelector('[name="contact[Occasion]"]') || {}).value || 'Not specified';
      var budget = (form.querySelector('[name="contact[Estimated Budget]"]') || {}).value || 'Not specified';
      var format = (form.querySelector('[name="contact[Preferred Format]"]') || {}).value || 'Not specified';
      var flowers = (form.querySelector('[name="contact[Preferred Flowers]"]') || {}).value || 'Not specified';
      var colours = (form.querySelector('[name="contact[Preferred Colours]"]') || {}).value || 'Not specified';
      var emirate = (form.querySelector('[name="contact[Delivery Emirate]"]') || {}).value || 'Not specified';
      var date = (form.querySelector('[name="contact[Preferred Date]"]') || {}).value || 'Not specified';

      if (subjectInput) {
        subjectInput.value = '🌹 New Custom Arrangement Request - ' + customerName;
      }

      var arrangementDossier = [
        '==================================================',
        '🌹 NEW BESPOKE REQUEST: CREATE YOUR ARRANGEMENT',
        '==================================================',
        '• Client Name: ' + customerName,
        '• Phone / WhatsApp: ' + customerPhone,
        '• Email Address: ' + customerEmail,
        '• Occasion: ' + occasion,
        '• Estimated Budget: ' + budget,
        '• Preferred Format: ' + format,
        '• Preferred Flowers: ' + flowers,
        '• Preferred Colours: ' + colours,
        '• Delivery Emirate: ' + emirate,
        '• Preferred Delivery Date: ' + date,
        '',
        '• Arrangement Description & Client Vision:',
        rawNotes || 'No additional vision notes entered.',
        '=================================================='
      ].join('\n');

      if (bodyTextarea) {
        bodyTextarea.value = arrangementDossier;
      }
    } else if (isContact) {
      var inquirySubject = (form.querySelector('[name="contact[Inquiry Subject]"]') || form.querySelector('select[name="contact[Subject]"]') || {}).value || 'General Inquiry';

      if (subjectInput) {
        subjectInput.value = '📩 Contact Us Inquiry: ' + inquirySubject + ' - ' + customerName;
      }

      var contactDossier = [
        '==================================================',
        '📩 NEW CONTACT US INQUIRY',
        '==================================================',
        '• Client Name: ' + customerName,
        '• Phone / WhatsApp: ' + customerPhone,
        '• Email Address: ' + customerEmail,
        '• Inquiry Subject: ' + inquirySubject,
        '',
        '• Customer Message:',
        rawNotes || 'No message entered.',
        '=================================================='
      ].join('\n');

      if (bodyTextarea) {
        bodyTextarea.value = contactDossier;
      }
    } else if (isCorp) {
      var company = (form.querySelector('[name="contact[Company]"]') || {}).value || 'Not specified';
      var corpOccasion = (form.querySelector('[name="contact[Event Occasion]"]') || {}).value || 'Not specified';
      var volume = (form.querySelector('[name="contact[Estimated Quantity]"]') || {}).value || 'Not specified';
      var corpBudget = (form.querySelector('[name="contact[Estimated Budget]"]') || {}).value || 'Not specified';
      var corpEmirate = (form.querySelector('[name="contact[Delivery Emirate]"]') || {}).value || 'Not specified';
      var corpDate = (form.querySelector('[name="contact[Event Date]"]') || {}).value || 'Not specified';

      if (subjectInput) {
        subjectInput.value = '🏢 Corporate Floral Inquiry: ' + company + ' - ' + customerName;
      }

      var corpDossier = [
        '==================================================',
        '🏢 NEW CORPORATE & BULK ORDER INQUIRY',
        '==================================================',
        '• Contact Name: ' + customerName,
        '• Company / Organization: ' + company,
        '• Phone / WhatsApp: ' + customerPhone,
        '• Email Address: ' + customerEmail,
        '• Event / Occasion: ' + corpOccasion,
        '• Estimated Volume / Quantity: ' + volume,
        '• Estimated Budget: ' + corpBudget,
        '• Delivery Emirate: ' + corpEmirate,
        '• Event / Delivery Date: ' + corpDate,
        '',
        '• Event & Bespoke Branding Details:',
        rawNotes || 'No specific notes entered.',
        '=================================================='
      ].join('\n');

      if (bodyTextarea) {
        bodyTextarea.value = corpDossier;
      }
    }
  }

  function initPhoneFields(scope) {
    var phoneFields = (scope || document).querySelectorAll('[data-phone-field]');
    phoneFields.forEach(function(field) {
      var countrySelect = field.querySelector('[data-phone-country]');
      var flagDisplay = field.querySelector('[data-phone-flag]');
      var codeDisplay = field.querySelector('[data-phone-code]');
      var numberInput = field.querySelector('[data-phone-number]');
      var hiddenInput = field.querySelector('[data-phone-full]');

      if (!countrySelect || !numberInput || !hiddenInput) return;

      function updatePhone() {
        var selectedOpt = countrySelect.options[countrySelect.selectedIndex];
        var flag = selectedOpt ? selectedOpt.getAttribute('data-flag') : '🇦🇪';
        var prefix = selectedOpt ? selectedOpt.value : '+971';

        if (flagDisplay) flagDisplay.textContent = flag;
        if (codeDisplay) codeDisplay.textContent = prefix;

        var raw = numberInput.value.trim();
        // Check if user pasted an international number starting with +
        if (raw.indexOf('+') === 0) {
          for (var i = 0; i < countrySelect.options.length; i++) {
            var optVal = countrySelect.options[i].value;
            if (raw.indexOf(optVal) === 0) {
              countrySelect.selectedIndex = i;
              if (flagDisplay) flagDisplay.textContent = countrySelect.options[i].getAttribute('data-flag');
              if (codeDisplay) codeDisplay.textContent = optVal;
              raw = raw.substring(optVal.length).trim();
              numberInput.value = raw;
              prefix = optVal;
              break;
            }
          }
        }

        // Clean redundant leading zero (e.g. 050 -> 50)
        var clean = raw.replace(/^0+/, '');
        hiddenInput.value = clean ? (prefix + ' ' + clean) : '';
      }

      countrySelect.addEventListener('change', updatePhone);
      numberInput.addEventListener('input', updatePhone);
      numberInput.addEventListener('change', updatePhone);

      // Initial run
      updatePhone();
    });
  }

  function initLuxuryDatepickers(scope) {
    var datepickers = (scope || document).querySelectorAll('[data-luxury-datepicker]');
    datepickers.forEach(function(picker) {
      if (picker._calInit) return;
      picker._calInit = true;

      var trigger = picker.querySelector('[data-date-trigger]');
      var displayInput = picker.querySelector('[data-date-display]');
      var hiddenInput = picker.querySelector('[data-date-hidden]');
      var popover = picker.querySelector('[data-calendar-popover]');
      var titleEl = picker.querySelector('[data-cal-month-year]');
      var daysEl = picker.querySelector('[data-cal-days]');
      var prevBtn = picker.querySelector('[data-cal-prev]');
      var nextBtn = picker.querySelector('[data-cal-next]');
      var quickBtns = picker.querySelectorAll('[data-cal-quick]');

      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var currentViewMonth = today.getMonth();
      var currentViewYear = today.getFullYear();
      var selectedDate = null;

      // Check if hidden input has initial value
      if (hiddenInput && hiddenInput.value) {
        var parts = hiddenInput.value.split('-');
        if (parts.length === 3) {
          selectedDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
          currentViewMonth = selectedDate.getMonth();
          currentViewYear = selectedDate.getFullYear();
          updateDisplay();
        }
      }

      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var monthShortNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      function renderDays() {
        if (!daysEl || !titleEl) return;
        titleEl.textContent = monthNames[currentViewMonth] + ' ' + currentViewYear;

        daysEl.innerHTML = '';
        var firstDayIndex = new Date(currentViewYear, currentViewMonth, 1).getDay();
        var daysInMonth = new Date(currentViewYear, currentViewMonth + 1, 0).getDate();

        // Empty lead cells
        for (var i = 0; i < firstDayIndex; i++) {
          var emptyCell = document.createElement('span');
          emptyCell.className = 'lr-cal-day is-empty';
          daysEl.appendChild(emptyCell);
        }

        for (var d = 1; d <= daysInMonth; d++) {
          var dayDate = new Date(currentViewYear, currentViewMonth, d);
          dayDate.setHours(0, 0, 0, 0);

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'lr-cal-day';
          btn.textContent = d;

          if (dayDate < today) {
            btn.classList.add('is-disabled');
            btn.disabled = true;
          } else {
            if (dayDate.getTime() === today.getTime()) {
              btn.classList.add('is-today');
            }
            if (selectedDate && dayDate.getTime() === selectedDate.getTime()) {
              btn.classList.add('is-selected');
            }
            (function(dateObj) {
              btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                selectedDate = new Date(dateObj);
                updateDisplay();
                renderDays();
                closePopover();
              });
            })(dayDate);
          }

          daysEl.appendChild(btn);
        }
      }

      function updateDisplay() {
        if (!selectedDate) {
          if (displayInput) displayInput.value = '';
          if (hiddenInput) hiddenInput.value = '';
          return;
        }
        var yyyy = selectedDate.getFullYear();
        var mm = String(selectedDate.getMonth() + 1).padStart(2, '0');
        var dd = String(selectedDate.getDate()).padStart(2, '0');

        var dayName = dayNames[selectedDate.getDay()];
        var monthName = monthShortNames[selectedDate.getMonth()];

        if (displayInput) {
          displayInput.value = dayName + ', ' + selectedDate.getDate() + ' ' + monthName + ' ' + yyyy;
        }
        if (hiddenInput) {
          hiddenInput.value = yyyy + '-' + mm + '-' + dd;
        }
      }

      function openPopover() {
        document.querySelectorAll('.lr-luxury-datepicker.is-open').forEach(function(p) {
          if (p !== picker) p.classList.remove('is-open');
        });
        picker.classList.add('is-open');
        renderDays();
      }

      function closePopover() {
        picker.classList.remove('is-open');
      }

      if (trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (picker.classList.contains('is-open')) {
            closePopover();
          } else {
            openPopover();
          }
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          currentViewMonth--;
          if (currentViewMonth < 0) {
            currentViewMonth = 11;
            currentViewYear--;
          }
          renderDays();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          currentViewMonth++;
          if (currentViewMonth > 11) {
            currentViewMonth = 0;
            currentViewYear++;
          }
          renderDays();
        });
      }

      quickBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var action = btn.getAttribute('data-cal-quick');
          if (action === 'today') {
            selectedDate = new Date(today);
            currentViewMonth = selectedDate.getMonth();
            currentViewYear = selectedDate.getFullYear();
            updateDisplay();
            renderDays();
            closePopover();
          } else if (action === 'tomorrow') {
            var tom = new Date(today);
            tom.setDate(tom.getDate() + 1);
            selectedDate = tom;
            currentViewMonth = selectedDate.getMonth();
            currentViewYear = selectedDate.getFullYear();
            updateDisplay();
            renderDays();
            closePopover();
          } else if (action === 'clear') {
            selectedDate = null;
            updateDisplay();
            renderDays();
            closePopover();
          }
        });
      });

      // Close on click outside
      document.addEventListener('click', function(e) {
        if (!picker.contains(e.target)) {
          closePopover();
        }
      });
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    initPhoneFields(e.target);
    initLuxuryDatepickers(e.target);
  });
})();
